import { render, staticRenderFns } from "./VatHistory.vue?vue&type=template&id=3d808a97&scoped=true"
import script from "./VatHistory.vue?vue&type=script&lang=js"
export * from "./VatHistory.vue?vue&type=script&lang=js"
import style0 from "./VatHistory.vue?vue&type=style&index=0&id=3d808a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d808a97",
  null
  
)

export default component.exports